<template>
  <div
    :class="[
      'cost-card',
      {
        'base-banner': isBaseCard,
        'colorful-banner': isColoredCard,
        'card-double-width': editMode,
        'fixed-width': !editMode,
      },
    ]"
  >
    <div v-if="title" class="cost-card-header">
      <h3 class="cost-card-header-h">{{ title }}</h3>
    </div>
    <div class="cost-card-body">
      <section v-if="isBaseCard && !haveCosts" class="cost-card-body-no-costs">
        <p>There are no costs for links for this store yet.</p>
        <ButtonComponent variant="accent" class="cost-card-body-no-costs-start-add-button" @click="addPayment()">
          Add some
        </ButtonComponent>
      </section>
      <section v-if="haveCosts && !editMode" class="cost-card-body-cpc">
        <div v-for="(source, i) in trafficSources" :key="i">
          <template v-if="!(source.cpc === null && source.cpa === null)">
            <div class="cost-card-body-cpc-header">
              <img v-if="source.source === 1" src="../../assets/icons/instagram-costs-icon.svg" alt="icon" />
              <img v-else-if="source.source === 2" src="../../assets/icons/tiktok-costs-icon.svg" alt="icon" />
              <img v-else-if="source.source === 3" src="../../assets/icons/snapchat-costs-icon.svg" alt="icon" />
              <img v-else src="../../assets/icons/other-costs-icon.svg" alt="icon" />
              <h5>
                {{ trafficSourcesTemplates.find((el) => el.source === source.source)?.name }}
              </h5>
            </div>
            <div v-if="source.type === 'CPC'">
              <Cost
                v-if="baseTrafficSources.length"
                :value="source.cpc"
                :base-cost="
                  baseTrafficSources.find((el) => el.source === source.source)
                    ? baseTrafficSources.find((el) => el.source === source.source).cpc
                    : 0
                "
                type="cpc"
                :edit-mode="false"
              />
              <Cost v-else :value="source.cpc" :base-cost="trafficSources[i] ? trafficSources[i].cpc : 0" type="cpc" :edit-mode="false" />
            </div>
            <div v-if="source.type === 'CPA'">
              <Cost
                v-if="baseTrafficSources.length"
                :value="source.cpa"
                :base-cost="
                  baseTrafficSources.find((el) => el.source === source.source)
                    ? baseTrafficSources.find((el) => el.source === source.source).cpa
                    : 0
                "
                type="cpa"
                :edit-mode="false"
              />
              <Cost v-else :value="source.cpa" :base-cost="trafficSources[i] ? trafficSources[i].cpa : 0" type="cpa" :edit-mode="false" />
            </div>
          </template>
        </div>
      </section>
      <template v-if="haveCosts && editMode">
        <div>
          <button class="cost-card-body-edit-add-btn" @click="addPayment()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M8.25 9.75H4.5C4.2875 9.75 4.10925 9.678 3.96525 9.534C3.82125 9.39 3.7495 9.212 3.75 9C3.75 8.7875 3.822 8.60925 3.966 8.46525C4.11 8.32125 4.288 8.2495 4.5 8.25H8.25V4.5C8.25 4.2875 8.322 4.10925 8.466 3.96525C8.61 3.82125 8.788 3.7495 9 3.75C9.2125 3.75 9.39075 3.822 9.53475 3.966C9.67875 4.11 9.7505 4.288 9.75 4.5V8.25H13.5C13.7125 8.25 13.8908 8.322 14.0348 8.466C14.1788 8.61 14.2505 8.788 14.25 9C14.25 9.2125 14.178 9.39075 14.034 9.53475C13.89 9.67875 13.712 9.7505 13.5 9.75H9.75V13.5C9.75 13.7125 9.678 13.8908 9.534 14.0348C9.39 14.1788 9.212 14.2505 9 14.25C8.7875 14.25 8.60925 14.178 8.46525 14.034C8.32125 13.89 8.2495 13.712 8.25 13.5V9.75Z"
                fill="#000000"
              />
            </svg>
            Add Payment
          </button>
        </div>
        <section class="cost-card-body-edit">
          <template v-for="(source, index) in costSources">
            <div v-if="!(source.cpc === null && source.cpa === null)" :key="index" class="cost-card-body-edit-item">
              <div class="cost-card-body-edit-item-body">
                <div class="cost-card-body-edit-item-social">
                  <div class="cost-card-body-edit-item-body-header">
                    <h4>Traffic Source</h4>
                    <el-tooltip placement="bottom-start" effect="light">
                      <el-button round size="small" circle class="cost-card-body-edit-item-body-trigger">
                        <img src="../../assets/icons/help-old.svg" alt="help" />
                      </el-button>
                      <template #content>
                        <div class="cost-card-body-edit-item-body-tooltip">
                          <div class="cost-card-body-edit-item-body-tooltip-item">
                            <h6>Instagram</h6>
                            <p>Traffic coming from native Instagram app.</p>
                          </div>
                          <div class="cost-card-body-edit-item-body-tooltip-item">
                            <h6>TikTok</h6>
                            <p>Traffic coming from native TikTok app.</p>
                          </div>
                          <div class="cost-card-body-edit-item-body-tooltip-item">
                            <h6>Snapchat</h6>
                            <p>Traffic coming from native Snapchat app.</p>
                          </div>
                          <div class="cost-card-body-edit-item-body-tooltip-item">
                            <h6>Other</h6>
                            <p>
                              Traffic coming from any other source, e.g. websites (blogs, YouTube), messaging apps (WhatsApp, Telegram) and
                              manual link sharing.
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-tooltip>
                  </div>
                  <el-select
                    v-model="source.source"
                    class="cost-card-body-edit-item-select"
                    placeholder="Select source"
                    multiple
                    size="large"
                    @change="changeSource(source)"
                  >
                    <el-option
                      v-for="trafficSource in trafficSourcesTemplates"
                      v-show="!source.source.includes(trafficSource.source)"
                      :key="trafficSource.source"
                      class="cost-card-body-edit-item-select-option"
                      :value="trafficSource.source"
                      :label="trafficSource.name"
                    />
                    <el-option
                      key="all"
                      class="cost-card-body-edit-item-select-option"
                      value="all"
                      label="Select all"
                      :disabled="source.source.length === trafficSourcesTemplates.length"
                    />
                  </el-select>
                </div>
                <div class="cost-card-body-edit-item-rates">
                  <div class="cost-card-body-edit-item-rate">
                    <h4 class="cost-card-body-edit-h">CPC</h4>
                    <div class="cost-card-body-edit-item-rate-value">
                      <div class="cost-card-body-edit-item-input-wrapper">
                        <input v-model="source.cpc" type="number" step="0.1" @input="source.cpa = 0" />
                        <p class="cost-card-body-edit-item-input-text">{{ getCurrencySymbol() }} / Click</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="enableCpa" class="cost-card-body-edit-item-rate">
                    <h4 class="cost-card-body-edit-h">CPA</h4>
                    <div class="cost-card-body-edit-item-rate-value">
                      <div class="cost-card-body-edit-item-input-wrapper">
                        <input v-model="source.cpa" type="number" step="10" max="100" min="0" @input="source.cpc = 0" />
                        <p class="cost-card-body-edit-item-input-text">% / Sale</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cost-card-body-edit-item-delete">
                <img src="../../assets/icons/delete-cost.svg" alt="Delete" @click="deleteSource(source)" />
              </div>
            </div>
          </template>
        </section>
      </template>
      <section v-if="haveCosts" class="cost-card-body-btn">
        <el-button v-if="!editMode && Object.keys(trafficSources).length" round @click="editMode = true">
          Edit <i class="el-icon-edit"></i>
        </el-button>
        <ButtonComponent v-if="editMode" variant="accent" @click="saveChange"> Save </ButtonComponent>
        <div v-if="errorMessage" class="error-text">
          {{ errorMessage }}
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import { mapGetters } from 'vuex'

import Cost from './Cost.vue'

import { getCurrencySymbol } from '@/legacy/store/helpFunctions'

export default {
  name: 'CostCard',
  components: {
    Cost,
  },
  props: {
    title: String,
    isBaseCard: Boolean,
    enableCpa: Boolean,
    isColoredCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    trafficSources: {
      type: Array,
      required: true,
    },
    baseTrafficSources: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ['saveNewCosts'],
  data: function () {
    return {
      editMode: false,
      costSources: [],
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters('trafficSources', ['trafficSourcesTemplates']),
    haveCosts() {
      let costs = false
      this.costSources.forEach((el) => {
        if (el.cpc !== null || el.cpa !== null) {
          costs = true
        }
      })
      return costs
    },
  },
  mounted() {
    for (let i = 0; i < this.trafficSources.length; i++) {
      const temp = {
        cpc: this.trafficSources[i].cpc,
        cpa: this.trafficSources[i].cpa,
        source: [this.trafficSources[i].source],
      }
      if (this.costSources.length === 0) {
        this.costSources.push(temp)
      } else {
        let sameCosts = false
        for (let j = 0; j < this.costSources.length; j++) {
          if (this.costSources[j].cpc === temp.cpc && this.costSources[j].cpa === temp.cpa) {
            sameCosts = true
            if (!this.costSources[j].source.includes(this.trafficSources[i].source)) {
              this.costSources[j].source.push(this.trafficSources[i].source)
            }
          }
        }
        if (!sameCosts) {
          this.costSources.push(temp)
        }
      }
    }
  },
  methods: {
    getCurrencySymbol,
    deleteSource(source) {
      const idx = this.costSources.indexOf(source)
      this.costSources.splice(idx, 1)
    },
    changeSource(source) {
      if (source.source.includes('all')) {
        const temp = this.costSources.find((el) => el.source.includes('all'))
        temp.source = this.trafficSourcesTemplates.map((el) => el.source)
      }
      const filteredSources = this.costSources.filter((el) => el !== source)
      for (let i = 0; i < source.source.length; i++) {
        const temp = filteredSources.find((el) => el.source.includes(source.source[i]))
        if (temp) {
          temp.source = temp.source.filter((el) => el !== source.source[i])
        }
      }
    },
    saveChange() {
      const savedCostSources = []
      this.errorMessage = ''
      for (let i = 0; i < this.costSources.length; i++) {
        const temp = { ...this.costSources[i] }
        if ((temp.cpc > 0 || temp.cpa > 0) && temp.source.length) {
          if (temp.cpa > 100) {
            this.errorMessage = 'CPA should be between 0 and 100'
          } else {
            for (let j = 0; j < temp.source.length; j++) {
              const newSource = {
                cpc: Number(temp.cpc),
                cpa: Number(temp.cpa),
                source: temp.source[j],
                type: temp.cpa ? 'CPA' : 'CPC',
              }
              savedCostSources.push(newSource)
            }
          }
        }
      }

      if (!this.errorMessage) {
        savedCostSources.sort((a, b) => (a.source > b.source ? 1 : -1))
        this.$emit('saveNewCosts', savedCostSources)
        this.editMode = false
      }
    },
    addPayment() {
      const emptySource = {
        source: [],
        cpc: 0,
        cpa: 0,
      }
      this.costSources.unshift(emptySource)
      this.editMode = true
    },
  },
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type='number'] {
  -moz-appearance: textfield; /* Firefox */
}
.fixed-width {
  width: 320px;
}
.error-text {
  color: var(--danger);
}
.cost-card {
  max-width: 656px;
  border: 0;
  -webkit-box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  border-radius: 0;
  display: flex;
  flex-direction: column;
  padding: 32px;

  @media (max-width: 600px) {
    max-width: calc(100% - 32px);
  }

  &-header {
    background: transparent;
    margin-bottom: 1rem;
    position: relative;

    &-h {
      color: #000;
      font-size: 18px;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 0;
      &:after {
        content: '';
        background: var(--orange);
        bottom: -7px;
        left: 0;
        height: 2px;
        position: absolute;
        width: 64px;
      }
    }
  }

  &-body {
    display: flex;
    flex: 1;
    flex-direction: column;
    position: relative;
    min-width: 256px;

    @media (max-width: 600px) {
      flex-direction: column;
      padding-bottom: 72px;
    }

    @media (max-width: 370px) {
      padding-left: 12px;
      padding-right: 12px;
    }

    &-no-costs {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-start-add-button {
        margin-top: 40px;
      }
    }

    &-cpc-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 16px;
      margin-bottom: 8px;
    }

    &-edit {
      display: flex;
      flex-direction: column;
      gap: 24px;

      &-item {
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #e6e9ee;
        background: #fdfdfd;
        gap: 16px;
        padding: 16px;
        @media (max-width: 768px) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        &-select {
          width: 100%;
        }
        &-body {
          width: 100%;
          &-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 4px;
          }
          &-trigger {
            background: white;
            border: none;
            width: 18px;
            height: 18px;
            padding: 1px;
          }
          &-tooltip {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 16px;
            &-item {
              text-align: start;
              h6 {
                text-align: start;
                color: #000;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                margin-bottom: 4px;
              }
              p {
                text-align: start;
                margin-bottom: 0;
                color: #636363;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
              }
            }
          }
        }
        h4 {
          color: #374757;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          white-space: nowrap;
          margin-bottom: 0;
        }
        &-type {
          width: 100%;
          max-width: 110px;
        }
        &-input-wrapper {
          position: relative;
        }
        &-input-text {
          position: absolute;
          top: 30%;
          right: 12px;
          color: #b3b7bf;
          font-size: 12px;
          line-height: 24px;
        }
        &-rates {
          margin-top: 16px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          @media (max-width: 768px) {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
        }
        &-rate {
          width: 100%;
          &-value {
            input {
              width: 100%;
              padding: 16px;
              border-radius: 8px;
              height: 56px;
              border: 1px solid #dcdfe6;
            }
            p {
              margin-bottom: 0;
            }
          }
        }
        &-delete {
          text-align: center;
          @media (max-width: 768px) {
            width: 100%;
            text-align: end;
          }
          img {
            cursor: pointer;
          }
        }
      }
      &-add-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 24px 0;
        color: #000000;
        border-radius: 4px;
        border: 1px solid #000000;
        background: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        padding: 10px 24px 10px 16px;
      }
    }

    hr {
      margin-top: 24px;
      margin-bottom: 8px;
      height: 1px;
      width: 100%;
      border: none;
      background: #dcdee4;
    }

    &-btn {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-top: 16px;
    }
  }

  h5 {
    color: #636363;
    font-size: 16px;
    margin-bottom: 0;
  }
}

.card-double-width {
  @media (min-width: 601px) {
    width: 656px;
    grid-column: span 2;
  }
}

.colorful-banner,
.base-banner {
  border-top: 12px solid #fff;
  position: relative;
}

.colorful-banner:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 12px;
  background: linear-gradient(to right, #e47b49, #ea4c89);
  top: -12px;
  left: 0;
  animation: animateIn 1s;
}

.base-banner::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 12px;
  background: linear-gradient(to right, #349fd6, #ea4c89);
  top: -12px;
  left: 0;
  animation: animateIn 1s;
}

@keyframes animateIn {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}
</style>
